<template>
  <div style="background-color:#F5F6F7;min-height: 100vh;">
    <div class="count-block">
      <div class="count-container">
        <div class="portraitimg" @click="toMaterial">
          <img :src="userInfo.headImg" alt="头像" />
        </div>
        <div>
          <p>{{ userInfo.nickName }}</p>
          <p>{{ userInfo.mobilePhone }}</p>
        </div>
      </div>
    </div>
    <div class="type-menu">
      <div class="type-item" :class="{ active: type === 'all' }">
        <div @click="switchType('all')">
          <span>全部</span>
        </div>
        <img class="arc-img" src="../../assets/img/common/down_arc.png" />
      </div>
      <div class="type-item" :class="{ active: type === 'waitPay' }">
        <div @click="switchType('waitPay')">
          <span>待支付</span>
        </div>
        <img class="arc-img" src="../../assets/img/common/down_arc.png" />
      </div>
      <div class="type-item" :class="{ active: type === 'examine_pass' }">
        <div @click="switchType('examine_pass')">
          <span>已支付</span>
        </div>
        <img class="arc-img" src="../../assets/img/common/down_arc.png" />
      </div>

      <!-- <div class="type-item" :class="{ active: type === 'selfAccSucess' }">
        <div @click="switchType('selfAccSucess')">
          <span>个账划扣</span>
          <img class="arc-img" src="../../assets/img/common/down_arc.png" />
        </div>
      </div> -->

      <div class="type-item" :class="{ active: type === 'effective' }">
        <div @click="switchType('effective')">
          <span>保障中</span>
        </div>
        <img class="arc-img" src="../../assets/img/common/down_arc.png" />
      </div>
      <div class="type-item" :class="{ active: type === 'unEffective' }">
        <div @click="switchType('unEffective')">
          <span>已失效</span>
        </div>
        <img class="arc-img" src="../../assets/img/common/down_arc.png" />
      </div>
    </div>
    <div class="list-block" v-if="type === 'all'">
      <policy-list :data-list="policyList" @loading="loadData"></policy-list>
      <div class="orderimg" v-if="policyList.length === 0">
        <img src="../../assets/img/user_center/order.png" alt="" />
        <p>暂时还没有订单</p>
      </div>
    </div>
    <div class="list-block" v-if="type === 'waitPay'">
      <policy-list :data-list="waiPayList" @loading="loadData"></policy-list>
      <div class="orderimg" v-if="waiPayList.length === 0">
        <img src="../../assets/img/user_center/order.png" alt="" />
        <p>暂时还没有订单</p>
      </div>
    </div>
    <div class="list-block" v-if="type === 'examine_pass'">
      <policy-list :data-list="theEndList" @loading="loadData"></policy-list>
      <div class="orderimg" v-if="theEndList.length === 0">
        <img src="../../assets/img/user_center/order.png" alt="" />
        <p>暂时还没有订单</p>
      </div>
    </div>
    <!-- <div class="list-block" v-if="type === 'selfAccSucess'">
      <policy-list :data-list="selfAccSucessList" @loading="loadData"></policy-list>
    </div> -->
    <div class="list-block" v-if="type === 'effective'">
      <policy-list :data-list="effectiveList" @loading="loadData"></policy-list>
      <div class="orderimg" v-if="effectiveList.length === 0">
        <img src="../../assets/img/user_center/order.png" alt="" />
        <p>暂时还没有订单</p>
      </div>
    </div>
    <div class="list-block" v-if="type === 'unEffective'">
      <policy-list
        :data-list="unEffectiveList"
        @loading="loadData"
      ></policy-list>
      <div class="orderimg" v-if="unEffectiveList.length === 0">
        <img src="../../assets/img/user_center/order.png" alt="" />
        <p>暂时还没有订单</p>
      </div>
    </div>
    <!-- <main-menu /> -->
  </div>
</template>

<script>
  import PolicyList from './component/PolicyList'
  import { FindUserInsurances } from '@/api/user'
  import { AppCode } from '../../util/auth'
  import { mapState } from 'vuex'
  // import MainMenu from '../../components/MainMenu'

  export default {
    name: 'UserPolicy',
    components: {
      // MainMenu,
      PolicyList
    },
    mixins: [],
    props: {},

    data() {
      return {
        type: '',
        policyList: [],
        hasTeYaoFeeInsu: false
      }
    },

    computed: {
      ...mapState(['userInfo']),
      waiPayList: function() {
        return this.policyList.filter(function(item) {
          return item.payStatus === 'waitPay'
        })
      },
      effectiveList: function() {
        return this.policyList.filter(function(item) {
          // 部分生效的单子也需要放到保障中  放开此处注释
          // return item.insuranceStatus === 'effective' || item.insuranceStatus === 'partEffective'
          return item.insuranceStatus === 'effective'
        })
      },
      unEffectiveList: function() {
        return this.policyList.filter(function(item) {
          return item.insuranceStatus === 'unEffective'
        })
      },
      theEndList: function() {
        return this.policyList.filter(function(item) {
          return (
            item.payStatus === 'payYet' ||
            item.payStatus === 'selfAccSucess' ||
            item.payStatus === 'partRefund'
          )
        })
      },
      // selfAccSucessList: function() {
      //   return this.policyList.filter(function(item) {
      //     return item.payStatus === 'selfAccSucess'
      //   })
      // },
      numInfo: function() {
        const obj = {
          effective: 0,
          waitPay: 0,
          nearEnd: 0
        }
        this.policyList.forEach(item => {
          if (item.insuranceStatus === 'effective') {
            obj.effective += 1
            if (item.endDate) {
              const endArr = item.endDate.split(/-\s:/g)
              const endMilli = new Date(...endArr).getTime()
              const now = Date.now()
              const gap = Math.floor((endMilli - now) / (1000 * 60 * 60 * 24))
              if (gap <= 30) {
                obj.nearEnd += 1
              }
            }
          }
          if (item.payStatus === 'waitPay') {
            obj.waitPay += 1
          }
        })
        return obj
      }
    },

    watch: {},

    created() {},

    mounted() {
      console.log(this.userInfo.mobilePhone, '111111111111111111')
      this.type = this.$route.params.type || 'all'
      if (this.userInfo.mobilePhone) {
        this.loadData()
      } else {
        this.$router.push({ path: '/user-center' })
      }
    },

    destroyed() {},
    methods: {
      // 跳转到个人资料
      toMaterial() {
        this.$router.push({ path: '/user-mean' })
      },
      switchType(type) {
        this.type = type
      },
      async loadData() {
        this.loading = true
        try {
          const res = await FindUserInsurances({
            pageSize: 300,
            pageNum: 1,
            // insuranceProductCode: 'P2811157',
            // insuranceProductCode: 'HN001',
            // appntMobileNumber: this.$store.state.userInfo.mobilePhone,
            appCodeId: AppCode
          })
          this.policyList = res && res.dataList ? res.dataList : []
          this.policyList.forEach(item => {
            item.isFreeInsu = /^1010A01201$/.test(
              item.insuranceProductCode.trim()
            )
            if (/^1010A01201$/.test(item.insuranceProductCode.trim())) {
              this.hasTeYaoFeeInsu = true
            }
          })
        } catch (e) {
          this.$notify({ type: 'danger', message: e.message })
        }
        this.loading = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .count-block {
    margin: px2rem(10, 375) 0;
    padding: px2rem(10, 375) 0;
    background-color: #fff;

    .count-container {
      width: 90%;
      margin: 0 auto;
      display: flex;
      justify-content: left;
      align-items: center;
      .portraitimg {
        width: 20%;
        margin-right: 20px;
        img {
          max-width: px2rem(160);
          max-height: px2rem(160);
          border-radius: 50%;
        }
      }
    }

    .count-item {
      flex-basis: 33.33333%;
      display: flex;
      justify-content: center;
      align-items: center;

      .count-img {
        text-align: center;

        img {
          width: px2rem(34, 375);
        }
      }

      .count-text {
        font-size: px2rem(14, 375);
        line-height: px2rem(20, 375);

        .count-num {
          color: $themeColor;
        }
      }
    }
  }

  .type-menu {
    display: flex;
    align-items: center;
    padding: px2rem(10, 375) 0 0 0;
    background-color: #fff;

    .type-item {
      flex-basis: 20%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      > div {
        position: relative;
        padding-bottom: 0.6rem;
        width: px2rem(45, 375);
        text-align: center;
        font-size: px2rem(14, 375);
        line-height: px2rem(22, 375);
        color: #4c4c4c;
      }

      .arc-img {
        position: absolute;
        left: 0;
        bottom: 0;
        display: none;
        width: 100%;
      }
    }

    .type-item.active {
      > div {
        color: #f6303b;
      }

      .arc-img {
        display: inline;
      }
    }
  }

  .list-block {
    width: px2rem(335, 375);
    margin: px2rem(20, 375) auto 0;
    background-color: #f5f6f7;
  }

  .rec-title {
    margin: px2rem(20, 375) 0;
    text-align: center;

    span {
      display: inline-block;
      vertical-align: middle;
      font-size: px2rem(16, 375);
      color: #333;
    }

    .mid-txt {
      margin: 0 px2rem(20, 375);
    }

    .line {
      width: px2rem(13, 375);
      height: 1px;
      background-color: #333;
    }
  }

  .rec-content {
    width: px2percent(335, 375);
    margin: 0 auto;
    padding: px2rem(40, 375) 0;
    background-color: #fff;
    box-shadow: 0 4px 16px 0 #eff5ff;
    border-radius: px2rem(10, 375);

    p {
      text-align: center;
    }

    .p1 {
      font-size: px2rem(30, 375);
      color: #333;
    }

    .p2 {
      font-size: px2rem(13, 375);
      line-height: px2rem(18, 375);
      margin: px2rem(12, 375) 0 px2rem(20, 375);
    }

    div {
      width: px2rem(245, 375);
      margin: 0 auto;
      text-align: center;
      background-color: #f5a623;
      color: #fff;
      font-size: px2rem(26, 375);
      line-height: px2rem(50, 375);
      border-radius: px2rem(25, 375);
      box-shadow: 0 2px 4px 0 #f5a623;
    }
  }
  .orderimg {
    margin: 150px auto;
    text-align: center;
    img {
      width: 100px;
    }
  }
</style>
